import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DashboardTile.css';

const DashboardTile = ({ title, icon, description, path, color = '#4285F4', disabled = false }) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (!disabled && path) {
      navigate(path);
    }
  };
  
  return (
    <div 
      className={`dashboard-tile ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      style={{ borderTopColor: color }}
    >
      <div className="tile-icon" style={{ backgroundColor: color }}>
        {icon}
      </div>
      <div className="tile-content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      {disabled && <div className="coming-soon-badge">Coming Soon</div>}
    </div>
  );
};

export default DashboardTile;
